/**
 * @module builder
 */

import type { UpdateableAreaSubstrate } from '../../area-substrates'
import type { BulkAction, SubstrateOperation } from '..'
import { updateSubstrateProduct } from '../update-substrate-product/update-substrate-product'

export function bulkOperateSubstrate(operation: SubstrateOperation): UpdateableAreaSubstrate {
  let newSubstrate = {
    ...operation.substrate
  }

  // Complete each action on this SubstrateOperation
  operation.actions.forEach((action: BulkAction) => {
    const updatedSubstrate = updateSubstrateProduct(action, newSubstrate)
    newSubstrate = updatedSubstrate
  })

  return newSubstrate
}
